<svc-dialog-primary
  dialogStyle="empty"
  [fullscreen]="['XS', 'SM']"
>
  <div
    svc-dialog-title
    class="flex flex-1 h-full items-center"
  >
    <img
      class="w-auto max-w-fit max-h-6"
      [src]="environment.logoImageNegative"
    />

    <div class="mx-auto">
      <span class="font-sans text-base leading-6 font-semibold tracking-[-0.01em] uppercase text-center">
        {{ 'ACTION PLAN' | transloco }}
      </span>
    </div>
  </div>

  <div
    svc-dialog-content
    class="flex flex-auto flex-col h-full min-h-0"
  >
    <div
      class="flex-auto min-h-0 px-4 ap-modal-content"
      [class.overflow-auto]="tabIndex !== actionPlanTabs.History"
      [class.overflow-hidden]="tabIndex === actionPlanTabs.History"
    >
      <svc-action-plan-form
        #actionPlanForm
        [mode]="modalConfig.mode"
        [notificationParams]="modalConfig.notificationParams"
        (combosLoaded)="onFormCombosLoaded()"
      ></svc-action-plan-form>

      <nav
        svcTestId="ap-form__section--tabs"
        class="w-full border-b"
        mat-tab-nav-bar
        mat-stretch-tabs="false"
        mat-align-tabs="center"
        [tabPanel]="tabPanel"
      >
        <div
          svcTestId="ap-form__tab--checklist"
          mat-tab-link
          [active]="tabIndex === actionPlanTabs.Checklist"
          (click)="selectTab(actionPlanTabs.Checklist)"
        >
          {{ 'Checklist' | transloco }}
          <mat-icon
            class="ml-3 mr-1 icon-size-3"
            svgIcon="heroicons_solid:clipboard-list"
            [class.text-primary]="tabIndex === actionPlanTabs.Checklist"
          ></mat-icon>
          <p
            svcTestId="ap-form__counter--checklist"
            class="font-normal text-base"
          >
            {{ checklistInfo?.completed ?? 0 }}/{{ checklistInfo?.total ?? 0 }}
          </p>
        </div>

        <div
          svcTestId="ap-form__tab--approval"
          mat-tab-link
          [active]="tabIndex === actionPlanTabs.Approval"
          [class.text-primary]="tabIndex === actionPlanTabs.Approval"
          (click)="selectTab(actionPlanTabs.Approval)"
        >
          {{ 'Aprovação' | transloco }}
        </div>

        <div
          svcTestId="ap-form__tab--history"
          mat-tab-link
          [active]="tabIndex === actionPlanTabs.History"
          (click)="selectTab(actionPlanTabs.History)"
        >
          <mat-icon
            class="icon-size-5 mr-1"
            svgIcon="heroicons_outline:clock"
            [class.text-slate-500]="tabIndex !== actionPlanTabs.History"
            [class.text-primary]="tabIndex === actionPlanTabs.History"
          ></mat-icon>
          {{ 'Histórico' | transloco }}
        </div>

        <div
          svcTestId="ap-form__tab--feed"
          mat-tab-link
          [active]="tabIndex === actionPlanTabs.Feed"
          (click)="selectTab(actionPlanTabs.Feed)"
          [disabled]="isAddMode"
        >
          <mat-icon
            class="icon-size-5 mr-1"
            svgIcon="heroicons_outline:chat-bubble-oval-left-ellipsis"
            [class.text-slate-500]="tabIndex !== actionPlanTabs.Feed"
            [class.text-primary]="tabIndex === actionPlanTabs.Feed"
          ></mat-icon>
          {{ 'Feed' | transloco }}
          @if (!isAddMode && feedTab?.svcCommentsChat && feedTab?.svcCommentsChat?.messages?.length >= 0) {
            <mat-icon
              class="ml-2.5 mr-1 icon-size-3"
              svgIcon="heroicons_solid:chat-alt"
              [class.text-primary]="tabIndex === actionPlanTabs.Feed"
            ></mat-icon>
            <p class="font-normal text-base">{{ feedTab?.svcCommentsChat?.messages?.length }}</p>
          }
        </div>
      </nav>

      <mat-tab-nav-panel
        #tabPanel
        class="hidden"
      ></mat-tab-nav-panel>

      <div
        svcTestId="ap-form-feed__section--content"
        class="action-plan-feed-tab"
        [hidden]="tabIndex !== actionPlanTabs.Feed"
      >
        @if (actionPlanForm?.actionPlanUniqueId) {
          <svc-action-plan-feed-tab
            #feedTab
            [svcTestId]="'ap-form-feed__section--comments-tab-id-' + actionPlanForm?.actionPlanUniqueId"
            [actionPlanId]="actionPlanForm?.actionPlanUniqueId ?? null"
            (commentsTotalChange)="onCommentsTotalChange($event)"
            (commentsChanged)="onCommentsChanged()"
          ></svc-action-plan-feed-tab>
        }
      </div>

      <div [hidden]="tabIndex !== actionPlanTabs.Checklist">
        <svc-action-plan-checklist-tab
          #checklistTab
          [actionPlanId]="loadedActionPlan?.actionPlanUniqueId ?? null"
          [actionPlan]="loadedActionPlan"
          [initialChecklist]="loadedChecklist"
          [mode]="modalConfig.mode"
          (changesPersisted)="onChecklistPersisted()"
        ></svc-action-plan-checklist-tab>
      </div>

      <div [hidden]="tabIndex !== actionPlanTabs.Approval">
        <svc-action-plan-approval-tab
          #approvalTab
          [mode]="modalConfig.mode"
          [approverControl]="actionPlanForm?.approverIdsControl"
          [usersOptions]="actionPlanForm?.usersOptions ?? []"
          [isLoading]="actionPlanForm?.isAllCombosLoading ?? false"
          [selectedApproverIds]="actionPlanForm?.selectedApproverIds ?? []"
          [selectedApproverLabels]="actionPlanForm?.selectedApproverLabels ?? []"
          [canEdit]="canEditApprover"
        ></svc-action-plan-approval-tab>
      </div>

      <div
        svcTestId="ap-form-history__section--content"
        class="action-plan-history-tab ap-history-scroll-host"
        [hidden]="tabIndex !== actionPlanTabs.History"
      >
        <svc-action-plan-history-tab
          #historyTab
          svcTestId="ap-form-history__section--timeline"
          [actionPlanId]="actionPlanForm?.actionPlanUniqueId ?? modalConfig?.id ?? null"
          [refreshTrigger]="historyRefreshTick"
        ></svc-action-plan-history-tab>
      </div>
    </div>

    @if (!isLoading && !isAddMode && actionPlanForm?.actionPlanUniqueId) {
      <div
        svcTestId="ap-form__section--interactions"
        class="border-t flex justify-between items-center px-4 py-2.5 w-full h-10"
      >
        <div class="flex gap-4 items-center justify-between py-2">
          <svc-bookmark-button
            svcTestId="ap-form__btn--bookmark"
            class="w-fit"
            [referenceId]="actionPlanForm?.actionPlanUniqueId"
            [applicationId]="applicationId"
            [iconAlwaysFilled]="true"
            (onValueChanged)="onBookmarkChanged($event)"
          />
          <svc-reaction
            svcTestId="ap-form__btn--reaction"
            class="flex flex-auto"
            #svcReaction
            [class]="svcReaction.hasReacted ? 'text-primary' : 'text-default'"
            [registryUniqueId]="actionPlanForm?.actionPlanUniqueId"
            [applicationId]="applicationId"
            [relativeFromElement]="['svc-dialog-primary .overflow-auto', 'body .cdk-global-overlay-wrapper']"
            positionX="left"
            [dontEmitFirstTime]="true"
            (onReactionChange)="onReactionChange($event)"
            (onLoadingChange)="isReactionLoading = $event"
            (click)="!isReactionLoading && (svcReaction.hasReacted ? svcReaction?.removeCurrentReaction() : svcReaction?.makeReactionByEnum('LIKE'))"
          >
            @if (!isReactionLoading) {
              <mat-icon
                class="icon-size-6 text-current"
                svgIcon="heroicons_solid:hand-thumb-up"
              />
            } @else {
              <ngx-skeleton-loader
                class="w-6 h-6"
                [theme]="{ width: '100%', height: '100%', borderRadius: '4px', marginBottom: 0 }"
              />
            }
          </svc-reaction>
          <div class="flex items-center text-default">
            <mat-icon
              svcTestId="ap-form__btn--feed-shortcut"
              svgIcon="mat_solid:comment"
              class="cursor-pointer text-current icon-size-6"
              (click)="goToFeedTab()"
            />
          </div>
        </div>
        <svc-totals-status
          svcTestId="ap-form__section--totals-status"
          class="h-fit self-end"
          [referenceId]="actionPlanForm?.actionPlanUniqueId"
          [applicationId]="applicationId"
          [configTypeId]="commentConfigType"
          [featureName]="featureName"
          [available]="{ reactions: true, comments: true, views: true }"
        />
      </div>
    }
  </div>

  <div
    svc-dialog-actions-options
    class="flex gap-2 items-center container-actions__shadow"
  >
    @if (showMoreOptions) {
      <button
        svcTestId="ap-form__icon-btn--more-options"
        mat-icon-button
        type="button"
        id="action-plan-register-more-options"
        class="text-on-primary"
        [disabled]="isLoading"
        [matMenuTriggerFor]="actionPlanMoreOptionsMenu"
      >
        <mat-icon
          class="text-current icon-size-6"
          svgIcon="heroicons_solid:ellipsis-vertical"
        ></mat-icon>
      </button>
    }

    <mat-menu
      svcTestId="ap-form__menu--more-options"
      #actionPlanMoreOptionsMenu="matMenu"
      xPosition="before"
      yPosition="above"
    >
      <ng-container *ngFor="let option of dialogActionOptions; trackBy: trackByActionOption">
        <button
          *ngIf="!option.hidden"
          [svcTestId]="getMoreOptionTestId(option)"
          mat-menu-item
          class="text-default action-plan-more-option"
          (click)="option.action?.()"
          [disabled]="option.disabled"
        >
          <span
            *ngIf="option.customIcon === 'copy'"
            class="action-plan-menu-icon action-plan-copy-menu-icon"
            aria-hidden="true"
          >
            <svg
              width="10"
              height="13"
              viewBox="0 0 10 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.2 0.8C3.2 0.358172 3.55817 0 4 0H5.6C6.04183 0 6.4 0.358172 6.4 0.8C6.4 1.24183 6.04183 1.6 5.6 1.6H4C3.55817 1.6 3.2 1.24183 3.2 0.8Z"
                fill="#4D4D4D"
              />
              <path
                d="M1.6 0.8C0.716344 0.8 0 1.51634 0 2.4V11.2C0 12.0837 0.716345 12.8 1.6 12.8H8C8.88366 12.8 9.6 12.0837 9.6 11.2V2.4C9.6 1.51634 8.88366 0.8 8 0.8C8 2.12548 6.92548 3.2 5.6 3.2H4C2.67452 3.2 1.6 2.12548 1.6 0.8Z"
                fill="#4D4D4D"
              />
            </svg>
          </span>
          <span
            *ngIf="option.customIcon === 'escalate'"
            class="action-plan-menu-icon action-plan-escalate-menu-icon"
            aria-hidden="true"
          >
            <svg
              width="20"
              height="12"
              viewBox="0 0 20 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12 2.4C11.3373 2.4 10.8 1.86274 10.8 1.2C10.8 0.537258 11.3373 0 12 0H18C18.6627 0 19.2 0.537258 19.2 1.2V7.2C19.2 7.86274 18.6627 8.4 18 8.4C17.3373 8.4 16.8 7.86274 16.8 7.2V4.09706L11.6485 9.24853C11.1799 9.71716 10.4201 9.71716 9.95147 9.24853L7.2 6.49706L2.04853 11.6485C1.5799 12.1172 0.820101 12.1172 0.351472 11.6485C-0.117157 11.1799 -0.117157 10.4201 0.351472 9.95147L6.35147 3.95147C6.8201 3.48284 7.5799 3.48284 8.04853 3.95147L10.8 6.70294L15.1029 2.4H12Z"
                fill="#4D4D4D"
              />
            </svg>
          </span>
          <i
            *ngIf="option.customIcon === 'clock'"
            class="fa-regular fa-clock action-plan-menu-icon action-plan-clock-menu-icon"
            aria-hidden="true"
          ></i>
          <mat-icon
            *ngIf="!option.customIcon && option.icon"
            class="text-current"
            [class.action-plan-menu-icon]="true"
            [svgIcon]="option.icon"
          ></mat-icon>
          <span>{{ option.name }}</span>
        </button>
      </ng-container>
    </mat-menu>

    <svc-button
      svcTestId="ap-form__btn--close"
      class="ap-modal-footer-button ap-modal-footer-button-close ml-auto"
      mode="stroked"
      color="on-primary"
      type="button"
      buttonId="action-plan-register-close"
      [class.opacity-40]="isLoading"
      [class.pointer-events-none]="isLoading"
      [attr.aria-disabled]="isLoading"
      (click)="closeModal()"
    >
      {{ isAddMode ? ('Cancelar' | transloco) : ('Fechar' | transloco) }}
    </svc-button>

    @if (isAddMode || isEditMode || showChecklistOnlySave) {
      <svc-button
        svcTestId="ap-form__btn--save"
        class="ap-modal-footer-button ap-modal-footer-button-primary"
        mode="flat"
        color="on-primary"
        type="button"
        buttonId="action-plan-register-save"
        [processing]="isLoading"
        [class.opacity-40]="!isAddMode && !isEditMode ? false : (!actionPlanForm?.validForms && !isLoading)"
        [class.pointer-events-none]="isLoading"
        [attr.aria-disabled]="isLoading"
        (click)="saveActionPlan()"
      >
        {{ isAddMode ? ('Incluir' | transloco) : ('Salvar' | transloco) }}
      </svc-button>
    }

    @if (showFinalizeButton) {
      <svc-button
        svcTestId="ap-form__btn--finalize"
        class="ap-modal-footer-button ap-modal-footer-button-primary"
        mode="flat"
        color="on-primary"
        type="button"
        [processing]="isLoading"
        (click)="finalizeActionPlan()"
      >
        {{ 'Finalizar' | transloco }}
      </svc-button>
    }

    @if (showApprovalButton) {
      <svc-action-plan-approval-button
        [processing]="isLoading"
        (onApprove)="approveActionPlan()"
        (onReject)="rejectActionPlan()"
      ></svc-action-plan-approval-button>
    }

    @if (showReopenButton) {
      <svc-button
        svcTestId="ap-form__btn--reopen"
        class="ap-modal-footer-button ap-modal-footer-button-primary"
        mode="flat"
        color="on-primary"
        type="button"
        [processing]="isLoading"
        (click)="reopenActionPlan()"
      >
        {{ 'Reopen' | transloco }}
      </svc-button>
    }
  </div>
</svc-dialog-primary>
